import React from "react";
import { IconProps } from "../icon";

export const RefreshCw_04Icon = ({ size = "24px", color = "#000", ...props }: IconProps<string, string>) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M17 5.125A8.5 8.5 0 0112 20.5h-.5M7 18.875A8.5 8.5 0 0112 3.5h.5m.5 18.9l-2-2 2-2M11 5.6l2-2-2-2"
    />
  </svg>
);
